export const getProductSelector = (state: any) => state;

export const getProductSeries = (state: any) => state.product.productSeries;
export const getCurrentSeriesIndex = (state: any) => state.product.currentSeriesIndex;
export const getSelectedProduct = (state: any) => state.product.selectedProduct;